import { colorPalette } from '@shared/config/colorsConfig';
import type { TDocumentStatus, TDocumentStatusStyle } from '../types';

export const DOCUMENTS_ROW = {
    iconSize: 26,
    chevronSize: 18,
} as const;

export const DOCUMENTS_ICON = {
    color: colorPalette.secondary[600],
    statusSize: 14,
} as const;

export const DOCUMENTS_PULSE_ICON_PATH = 'M2 12h4.5l2.5-7.5 4 15 2.5-7.5H22';

export const DOCUMENTS_UNOPENED_BADGE_MAX = 99;

export const DOCUMENTS_PER_PAGE = 100;

export const DOCUMENTS_PDF_MIME = 'application/pdf';

export const DOCUMENTS_MONTH_KEYS = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
] as const;

export const DOCUMENT_STATUS_STYLE: Record<TDocumentStatus, TDocumentStatusStyle> = {
    uploadedByProfessional: { icon: 'medicine-box', variant: 'primary', iconColor: colorPalette.primary[700] },
    pendingProfessionalView: { icon: 'clock-circle', variant: 'warning', iconColor: colorPalette.warning[700] },
    viewedByProfessional: { icon: 'check', variant: 'success', iconColor: colorPalette.success[700] },
};
